import { ExclusiveChoiceDropdown, SingleLineTextInput } from "dash-styled"

interface EnumOption {
    label: string
    value: string
}

const LLM_MODELS: EnumOption[] = [
    {
        label: "GPT-3.5 Turbo 0301 EU",
        value: "gpt-35-turbo-0301-eu"
    },
    {
        label: "GPT-3.5 Turbo 0613 EU",
        value: "gpt-35-turbo-0613-eu"
    },
    {
        label: "GPT-3.5 Turbo 0613 World",
        value: "gpt-35-turbo-0613-world"
    },
    {
        label: "GPT-3.5 Turbo 16K 0613 EU",
        value: "gpt-35-turbo-16k-0613-eu"
    },
    {
        label: "GPT-3.5 Turbo 16K 0613 World",
        value: "gpt-35-turbo-16k-0613-world"
    },
    {
        label: "GPT-4 0613 EU",
        value: "gpt-4-0613-eu"
    },
    {
        label: "GPT-4 0613 World",
        value: "gpt-4-0613-world"
    },
    {
        label: "GPT-4-32K 0613 EU",
        value: "gpt-4-32k-0613-eu"
    },
    {
        label: "GPT-4-32K 0613 World",
        value: "gpt-4-32k-0613-world"
    }
]

const DOC_REPRESENTATIONS: EnumOption[] = [
    {
        label: "Line based",
        value: "line"
    },
    {
        label: "Whitespace based",
        value: "whitespace"
    },
    {
        label: "Whitespaces with OCR Tables",
        value: "whitespace_with_tables"
    }
]

const TABLE_MATCHING_METHODS: EnumOption[] = [
    {
        label: "Using OCR table headers",
        value: "ocr_tables"
    },
    {
        label: "Using full document text",
        value: "document_text"
    }
]

const BBOX_MATCHING_METHODS: EnumOption[] = [
    {
        label: "Fuzzy search",
        value: "base"
    },
    {
        label: "Levenshtein metric search",
        value: "levenshtein"
    }
]

export const LLMParams = ({
    llmParams,
    onChange
}: {
    llmParams: any
    onChange: (llmParams: any) => void
}) => {
    const hanleModelClick = (item: EnumOption) => {
        onChange({
            ...llmParams,
            foundation_model: item.value
        })
    }
    const hanleDocRepresentationClick = (item: EnumOption) => {
        onChange({
            ...llmParams,
            document_representation: item.value
        })
    }
    const hanleTableMatchingClick = (item: EnumOption) => {
        onChange({
            ...llmParams,
            table_matching_method: item.value
        })
    }
    const hanleBboxMatchingClick = (item: EnumOption) => {
        onChange({
            ...llmParams,
            bbox_matching_method: item.value
        })
    }
    return (
        <>
            <ExclusiveChoiceDropdown
                choices={LLM_MODELS}
                value={LLM_MODELS.find(
                    item =>
                        item.value ===
                        (llmParams.foundation_model ?? "gpt-35-turbo-0613-eu")
                )}
                renderChoice={item => item.label}
                size="sm"
                className="my-4"
                label="Foundation LLM Model"
                onClick={hanleModelClick}
            />
            <ExclusiveChoiceDropdown
                choices={DOC_REPRESENTATIONS}
                value={DOC_REPRESENTATIONS.find(
                    item =>
                        item.value ===
                        (llmParams.document_representation ?? "line")
                )}
                renderChoice={item => item.label}
                size="sm"
                className="my-4"
                label="Document Representation"
                onClick={hanleDocRepresentationClick}
            />
            <ExclusiveChoiceDropdown
                choices={TABLE_MATCHING_METHODS}
                value={TABLE_MATCHING_METHODS.find(
                    item =>
                        item.value ===
                        (llmParams.table_matching_method ?? "ocr_tables")
                )}
                renderChoice={item => item.label}
                size="sm"
                className="my-4"
                label="Tables Matching Method"
                onClick={hanleTableMatchingClick}
            />
            <ExclusiveChoiceDropdown
                choices={BBOX_MATCHING_METHODS}
                value={BBOX_MATCHING_METHODS.find(
                    item =>
                        item.value ===
                        (llmParams.bbox_matching_method ?? "base")
                )}
                renderChoice={item => item.label}
                size="sm"
                className="my-4"
                label="Bounding Boxes Matching Method"
                onClick={hanleBboxMatchingClick}
            />
            <SingleLineTextInput
                value={llmParams.max_fields_in_prompt}
                type="number"
                min={0}
                onChange={e => {
                    let val = parseInt(e.target.value)
                    if (isNaN(val)) {
                        val = 0
                    }

                    onChange({
                        ...llmParams,
                        max_fields_in_prompt: val
                    })
                }}
                label="Max number of fields in single LLM prompt (0 - unlimited)"
            />
        </>
    )
}
